export const checkIsTet = (date: string) => {
  const fromDate = new Date(date || '');
  return new Date('2025-02-07').getTime() >= fromDate.getTime() && fromDate.getTime() >= new Date('2025-01-06').getTime();
};
